import script from "./cardapio-pastelaria.vue?vue&type=script&setup=true&lang=js"
export * from "./cardapio-pastelaria.vue?vue&type=script&setup=true&lang=js"

import "./cardapio-pastelaria.vue?vue&type=style&index=0&id=592bc80c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-592bc80c"]])

export default __exports__